import { render, staticRenderFns } from "./CreateItems.vue?vue&type=template&id=0d16c70c&scoped=true"
import script from "./CreateItems.vue?vue&type=script&lang=js"
export * from "./CreateItems.vue?vue&type=script&lang=js"
import style0 from "./CreateItems.vue?vue&type=style&index=0&id=0d16c70c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16c70c",
  null
  
)

export default component.exports